// TODO: Refactor to reduce redundancy.
export var SALogos;
(function (SALogos) {
    SALogos["noBrandingLogoBugWhite"] = "noBrandingLogoBugWhite";
    SALogos["noBrandingLogoWhite"] = "noBrandingLogoWhite";
    SALogos["stateAutoLogoBugWhite"] = "stateAutoLogoBugWhite";
    SALogos["stateAutoLogoWhite"] = "stateAutoLogoWhite";
})(SALogos || (SALogos = {}));
//# sourceMappingURL=logo.options.js.map